export default __webpack_public_path__ + "static/media/Sotheby.1d09e6ea.jpg";